import * as React from "react";



import { ComponentMap } from "../../tools/hydrator/@types/hydrator.types";



const LanguageSelector = React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@components/General/LanguageSelector/languageSelector.container"
    ).then(module => ({
        default: module.LanguageSelectorContainer,
    })),
);

const FlyoutButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Navigation/Flyout/flyoutButton.container"
    ).then(module => ({
        default: module.FlyoutButtonContainer,
    })),
);

const ImageViewer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Product/ImageViewer/imageViewer.container"
    ).then(module => ({
        default: module.ImageViewerContainer,
    })),
);

const ImageViewerFullWidth = React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@components/Product/ImageViewerFullWidth/imageViewerFullWidth.container"
    ).then(module => ({
        default: module.ImageViewerFullWidthContainer,
    })),
);

const ProductSlider = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Product/ProductSlider/productSlider.container"
    ).then(module => ({
        default: module.ProductSliderContainer,
    })),
);

const ProductTileAdapter = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Product/ProductTile/productTile.adapter"
    ).then(module => ({
        default: module.ProductTileAdapter,
    })),
);

const Categories = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Product/Categories/categorySlider.container"
    ).then(module => ({
        default: module.CategoriesContainer,
    })),
);

const AccountButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Account/AccountButton/accountButton.container"
    ).then(module => ({
        default: module.AccountButtonContainer,
    })),
);

const ProductComparisonBar = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Product/ProductComparisonBar/productComparisonBar.container"
    ).then(module => ({
        default: module.ProductComparisonBarContainer,
    })),
);

const WishlistHeaderButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Wishlist/WishlistHeaderButton/wishlistHeaderButton.container"
    ).then(module => ({
        default: module.WishlistHeaderButtonContainer,
    })),
);

const CartButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/CartButton/cartButton.container"
    ).then(module => ({
        default: module.CartButtonContainer,
    })),
);

const HeaderButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/HeaderButton/headerButton.container"
    ).then(module => ({
        default: module.HeaderButtonContainer,
    })),
);

const DebugNotification = React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@components/Utils/debugNotifiction/debugNotification.component"
    ).then(module => ({
        default: module.DebugNotification,
    })),
);

const ECommerce = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Product/ECommerce/eCommerce.container"
    ).then(module => ({
        default: module.ECommerceContainer,
    })),
);

const AlgoliaSearch = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Search/SearchAutocomplete/searchAutocomplete.wrapper"
    ).then(module => ({
        default: module.SearchAutocompleteWrapper,
    })),
);

const ProductBundles = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Product/ProductBundles/productBundles.container"
    ).then(module => ({
        default: module.ProductBundles,
    })),
);

const CallToAction = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/CallToAction/callToAction.container"
    ).then(module => ({
        default: module.CallToAction,
    })),
);

const NewsletterContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Newsletter/newsletter.container"
    ).then(module => ({
        default: module.NewsLetterContainer,
    })),
);

const ResetPasswordFormContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@components/Account/ResetPasswordForm/resetPasswordForm.container"
    ).then(module => ({
        default: module.ResetPasswordFormContainer,
    })),
);

//keys here match the enum name from -> be.hubo.hubofoundation.ssr.SsrComponentName


//keys here match the enum name from -> be.hubo.hubofoundation.ssr.SsrComponentName
export const componentMap: ComponentMap = {
    HEADER_BUTTON: HeaderButton,
    ACCOUNT_BUTTON: AccountButton,
    CART_BUTTON: CartButton,
    WISHLIST_HEADER_BUTTON: WishlistHeaderButton,
    PRODUCT_COMPARISON_BAR: ProductComparisonBar,
    LANGUAGE_SELECTOR: LanguageSelector,
    FLYOUT_BUTTON: FlyoutButton,
    IMAGE_VIEWER: ImageViewer,
    IMAGE_VIEWER_FULL_WIDTH: ImageViewerFullWidth,
    PRODUCT_SLIDER: ProductSlider,
    PRODUCT_TILE: ProductTileAdapter,
    CATEGORIES_SLIDER: Categories,
    DEBUG_NOTIFICATION: DebugNotification,
    ECOMMERCE: ECommerce,
    SEARCH_BAR: AlgoliaSearch,
    PRODUCT_BUNDLES: ProductBundles,
    CALL_TO_ACTION: CallToAction,
    NEWSLETTER: NewsletterContainer
};
